import { useOnDemandTableRequest } from './useOnDemandTableRequest';

export default useOnDemandTableRequest;
